import React from 'react'
import { Trans } from '@lingui/react/macro'
import { MUSIC_DEFAULT_CREDITS } from '@loc/server/constant/common'

import { PlansProvider, usePlansContext } from '../context'
import styles from '../Common/index.module.scss'
import FreePlanCard from '../PlanCard/FreePlanCard'
import PlanCard from '../PlanCard'
import SignUpBox from '../../Modals/Tips/SignUpModal/SignUpBox'

import {
  EPaidProductType,
  type ICommonPlansBlockProps,
  type IInnerProps,
} from '@/contexts/PlanContext/type'
import { ProductsSubAppName } from '@/contexts/SiteSpecificContext/types'
import InnerContent from '@/_blocks/Plan/InnerContent'
import { PayCard } from '@/_blocks/Plan/PayCard'
import { getProductValueByProductType } from '@/contexts/PlanContext/helpers/getProductValueByProductType'
import { EPricingStep } from '@/contexts/PlanContext/hooks/payStep'


import { tw, cls } from 'tagged-classnames-free';
export interface IPlansBlockProps extends ICommonPlansBlockProps {}

function Inner(props: IInnerProps) {
  const { className, ulClassName, cardClassName, durationClassName } = props

  const {
    allProductsList,
    payStepInfo,
    isActive,
    maxOutletsInfo,
    durationInfo,
    isAnonymousPayment,
    planProductListInfo,
  } = usePlansContext()

  const { maxOutlets } = maxOutletsInfo

  const { allProductsListMap } = planProductListInfo
  const freeProductMap = allProductsListMap.Free

  return (
    <InnerContent
      isAnonymousPayment={isAnonymousPayment}
      className={tw`
        mx-auto
        ${payStepInfo.step === EPricingStep.PAY ? 'max-w-[1080px]' : 'max-w-[830px]'}
        ${className}
      `}
      ulClassName={tw`
        ${ulClassName}
        grid-cols-1
        gap-4
      `}
      paymentContentProps={{
        payStepInfo,
        isActive,
      }}
      payClassName={cls`
        mx-auto
        max-w-[1060px]
      `}
      SignUpBox={
        <SignUpBox
          onSignInSuccess={() => {}}
          className={cls`bg-f-bg-container w-full max-w-[542px] border-none`}
          signUpWarperClassName='px-4 text-center'
        />
      }
      toggleComponentProps={{
        durationProps: {
          maxOutlets,
          durationInfo,
          className: cls`
            border-f-border
            bg-f-bg-disabled
            flex min-w-[132px] justify-center
            border
          `,
          btnClassName: (isActive) => cls`
             text-f-text-secondary
             border border-transparent
            ${isActive ? 'text-f-text-invert bg-f-other-4' : ''}
          `,
          saveUpClassName: ({ duration }) => {
            return cls`${styles.saveUpBg}`
          },
          saveUpTextClassName: ({ duration }) => {
            return cls`
              text-white
            `
          },
        },
      }}
      AfterBuyContent={
        <>
          <div
            className={cls`
              text-f-text-tertiary mt-4 text-center text-sm
            `}
          >
            <Trans>Note: Each song costs {MUSIC_DEFAULT_CREDITS} credits</Trans>
          </div>
          <PayCard />
        </>
      }
    >
      <FreePlanCard
        className={cardClassName}
        productInfo={freeProductMap.monthProductMap}
      />
      {allProductsList.map((productInfo, index) => {
        const key = index
        if (!productInfo.creditsProducts.length) {
          return null
        }
        const productValue = getProductValueByProductType({
          type: productInfo.type,
          map: {
            [EPaidProductType.BASIC]: {
              className: 'order-2',
            },
            [EPaidProductType.PRO]: {
              className: 'order-3 md:order-1 !bg-transparent',
            },
            [EPaidProductType.UNLIMITED]: {
              className: 'order-3',
            },
          },
        })

        return (
          <PlanCard
            className={tw`
              ${productValue.className}
              ${cardClassName}
            `}
            key={key}
            productInfo={productInfo}
          />
        )
      })}
    </InnerContent>
  )
}

const PlansBlock: React.FC<IPlansBlockProps> = (props) => {
  const {
    className,
    ulClassName,
    cardClassName,
    durationClassName,
    productList,
    ...initialValue
  } = props

  if (!(productList && productList.length)) {
    return null
  }
  return (
    <PlansProvider
      initialValue={{
        ...initialValue,
        productList,
        appName: ProductsSubAppName.App1,
      }}
    >
      <Inner
        ulClassName={ulClassName}
        className={className}
        cardClassName={cls`${cardClassName}`}
        durationClassName={durationClassName}
      />
    </PlansProvider>
  )
}

export default PlansBlock
